import Vue from 'vue'
import Vuex from 'vuex'
import item from './modules/item'
import nutri from './modules/nutri'
import category from './modules/category'
import brand from './modules/brand'
import search from './modules/search'
import filter from './modules/filter'
import { isMobile } from '../util'
import router from '../router';
import createLogger from '../plugins/logger'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const state = {
  type_list: [
    {value: "0", text: '캡슐,정'}, {value:"1", text: '분말'}, {value:"2", text: '음료'},
    {value: "3", text: '캔디'}, {value: "4", text: '젤리'}, {value: "5", text: '환'}, 
    {value: "6", text: '액상'}, {value: "7", text: '스프레이'}],
  feature_list: [{'value': 'stick', 'text': '스틱형'}, {'value': 'chewable', 'text': '츄어블'}],
  mall_list: [{value:'domestic', text:'국내'}, {value: 'imported', text: '해외 직구'}],
  isMobile: isMobile(),
  type: null
}

const mutations = {
}

const actions = {
}

export default new Vuex.Store({
  state,
  mutations,
  actions,
  modules: {
    item,
    nutri,
    category,
    brand,
    search,
    filter
  },
  strict: debug,
  plugins: debug ? [createLogger()] : []
})


// WEBPACK FOOTER //
// ./src/store/index.js